import { filterKickoffsInMainCluster } from 'arena-shared/kickoffCluster';

const NON_SLATE_STATUSES = new Set(['postponed', 'canceled', 'cancelled']);

function kickoffMs(game) {
  if (game?.gameDate == null) return null;
  const ms = Number(game.gameDate);
  return Number.isFinite(ms) ? ms : null;
}

function hasScoreline(game) {
  const home = Number(game?.homeScore);
  const away = Number(game?.awayScore);
  return Number.isFinite(home) && Number.isFinite(away);
}

/**
 * True when this kickoff is earlier than the round's main matchday cluster
 * (early-played outliers lose to the upcoming slate).
 */
function isBeforeMainSlate(game, roundGames) {
  const thisKickoff = kickoffMs(game);
  const allKickoffs = (Array.isArray(roundGames) ? roundGames : [])
    .filter((g) => !NON_SLATE_STATUSES.has(String(g?.status || '').toLowerCase()))
    .map(kickoffMs)
    .filter((ms) => ms != null);
  if (thisKickoff == null || allKickoffs.length === 0) return false;
  const slate = filterKickoffsInMainCluster(allKickoffs);
  if (slate.length === 0) return false;
  return thisKickoff < Math.min(...slate);
}

/**
 * Status badge text for a match card.
 * Fixtures played before the round's remaining slate show as "Played early"
 * (finished, or postponed with a stored scoreline) instead of Finished/Postponed.
 *
 * @param {{ status?: string, gameDate?: number|string|Date, homeScore?: number|null, awayScore?: number|null }} game
 * @param {Array<{ status?: string, gameDate?: number|string|Date }>} [roundGames]
 * @returns {string}
 */
export function getGameStatusLabel(game, roundGames = []) {
  const status = String(game?.status || '').toLowerCase();
  const beforeSlate = isBeforeMainSlate(game, roundGames);

  if (status === 'finished') {
    return beforeSlate ? 'Played early' : 'Finished';
  }
  if (status === 'postponed') {
    if (beforeSlate && hasScoreline(game)) return 'Played early';
    return 'Postponed';
  }
  if (status === 'canceled' || status === 'cancelled') {
    return 'Canceled';
  }
  return game?.status || 'Upcoming';
}
